class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Hover-intent open/close, desktop only (fine-pointer devices): a short delay before
    // opening avoids bouncing the panel open when the pointer merely passes over the nav
    // item on its way elsewhere, and a short delay before closing gives the pointer room
    // to travel from the summary into the dropdown without it closing mid-transit. Click
    // (native <details> behavior) and focus (onFocusOut, inherited) still work unchanged,
    // so touch and keyboard users are unaffected.
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      this.addEventListener('mouseenter', this.onMouseEnterMenu.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeaveMenu.bind(this));
    }

    this.panelsRoot = this.querySelector('[data-mega-menu-panels]');
    if (this.panelsRoot) {
      this.querySelectorAll('[data-mega-panel-trigger]').forEach((triggerLink) => {
        triggerLink.addEventListener('mouseenter', this.onPanelTriggerHover.bind(this, triggerLink));
        triggerLink.addEventListener('focus', this.onPanelTriggerHover.bind(this, triggerLink));
      });
    }
  }

  onMouseEnterMenu() {
    clearTimeout(this.closeTimeout);
    if (this.mainDetailsToggle.hasAttribute('open')) return;
    this.openTimeout = setTimeout(() => this.open(), 120);
  }

  onMouseLeaveMenu() {
    clearTimeout(this.openTimeout);
    this.closeTimeout = setTimeout(() => this.close(), 250);
  }

  onPanelTriggerHover(triggerLink) {
    const targetHandle = triggerLink.getAttribute('data-mega-panel-trigger');
    const targetPanel = this.panelsRoot.querySelector(`[data-mega-panel="${targetHandle}"]`);
    if (!targetPanel || targetPanel.hasAttribute('data-active')) return;

    this.panelsRoot.querySelectorAll('[data-active]').forEach((panel) => panel.removeAttribute('data-active'));
    targetPanel.setAttribute('data-active', '');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
